import { __rest } from 'tslib';
import { styled, Tag, SvgIcon } from '@teko/ui';
import React from 'react';

const getBorderColor = (props) => {
    return props.isActive ? props.theme.brand.primary : '#e0e0e0';
};
const getColor = (props) => {
    return props.isActive ? props.theme.brand.primary : '#333333';
};
const Wrapper = styled.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: ${props.activeBackground && props.isActive ? props.activeBackground : '#fff'};
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.isDisabled ? 'default' : 'pointer'};
  ${props.block ? 'width: 100%;' : ''}

  &:hover {
    background: ${props.isActive || props.isDisabled ? '' : '#f3f3f3'} ;
  }
  `);
const Title = styled.div((props) => `
  color: ${props.activeBackground && props.isActive ? getColor(props) : ''};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
 `);
const ActiveBorder = styled.div((props) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${props.stickySize === 'sm' ? '0px 20px 20px 0px' : '0px 36px 36px 0px'};
  border-color: transparent ${props.theme.brand.primary} transparent transparent;
`);
const Checked = styled.span((props) => `
  position: absolute;
  top: ${props.stickySize === 'sm' ? '-4px' : '0'};
  right: ${props.stickySize === 'sm' ? '2px' : '6px'};
  color: #fff;
  z-index: 0;
  font-size: ${props.stickySize === 'sm' ? '7px' : '10px'};
`);
const IconWrappper = styled.span `
  margin-left: 8px;
`;
const StyledTag = styled(Tag) `
  margin-left: 8px;
`;
const SubTitle = styled.p `
  margin-bottom: 0.5rem;
  color: #848788;
`;
const Overlay = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;
const SelectOption = (_a) => {
    var { title, subTitle, children, icon, tag, isActive, onClickOption, onClickIcon, onMouseEnter, activeBackground, stickySize, isDisabled } = _a, props = __rest(_a, ["title", "subTitle", "children", "icon", "tag", "isActive", "onClickOption", "onClickIcon", "onMouseEnter", "activeBackground", "stickySize", "isDisabled"]);
    return (React.createElement(Wrapper, Object.assign({ activeBackground: activeBackground, isActive: !isDisabled && isActive, onClick: (ev) => !isDisabled && onClickOption(ev), onMouseEnter: onMouseEnter, isDisabled: isDisabled }, props),
        isDisabled && React.createElement(Overlay, null),
        React.createElement(Title, { activeBackground: activeBackground, isActive: !isDisabled && isActive },
            title,
            " ",
            tag && React.createElement(StyledTag, Object.assign({}, tag)),
            icon && (React.createElement(IconWrappper, { onClick: onClickIcon },
                React.createElement(SvgIcon, Object.assign({}, icon))))),
        subTitle && React.createElement(SubTitle, null, subTitle),
        children,
        !isDisabled && isActive && (React.createElement(React.Fragment, null,
            React.createElement(ActiveBorder, { stickySize: stickySize }),
            React.createElement(Checked, { stickySize: stickySize }, "\u2713")))));
};

export { SelectOption };
